var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 774.602,
    height: 718,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 720,
    width: 776.602,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#092b4a",
    id: "svg_1",
    d: "m765.00261,395.40992l-49.812,-49.656c-6.438,-6.529 -16.938,-6.594 -23.375,0l-105.001,104.937l-120.125,120.375l-93.031,-93.125c-6.531,-6.562 -17.031,-6.562 -23.5,0l-49.719,49.688c-6.531,6.562 -6.531,17.062 0,23.562l104.781,104.875l17.969,17.875l31.688,31.812c6.562,6.562 17.188,6.562 23.562,0l49.625,-49.688l236.875,-237.094c6.625,-6.468 6.625,-16.968 0.063,-23.561zm-532.219,64.593l49.687,-49.812c42.469,-42.375 116.344,-42.438 158.781,0.062l25.312,25.312l113.751,-108.374l0,-320l-576,0l0,704l320,0l-91.531,-92.125c-43.781,-43.937 -43.781,-115.25 0,-159.063zm-36.469,-388.812l320,0l0,64l-320,0l0,-64zm0,128l320,0l0,64l-320,0l0,-64zm-64,192l-64,0l0,-64l64,0l0,64zm0,-128l-64,0l0,-64l64,0l0,64zm0,-128l-64,0l0,-64l64,0l0,64zm64,192l64,0l0,64l-64,0l0,-64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.efd79adfc640a2a00d3ff92312b6e2a4.svg";
export { ForwardRef as ReactComponent };